<div [formGroup]="form">
  <app-input [form]="form" formGroupName="title" placeHolder="Job Title"></app-input>

  <div class="mb-2">
    <label for="workItemMechanic" class="form-label noselect">Mechanic</label>
    <select id="workItemMechanic" class="form-select" formControlName="empUserId">
      <option value="">Unassigned</option>
      <option *ngFor="let mechanic of mechanics" [value]="mechanic.userId">
        {{ getMechanicDisplayName(mechanic) }}
      </option>
    </select>
  </div>

  <app-input [form]="form" formGroupName="miles" placeHolder="Miles" inputType="integer"></app-input>

  <div class="pricing-section">
    <h3 class="section-title noselect">Pricing</h3>

    <div class="pricing-mode noselect">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="pricingModeComputed"
               formControlName="pricingMode" value="computed">
        <label class="form-check-label" for="pricingModeComputed">Parts + Labor</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="pricingModeFlat"
               formControlName="pricingMode" value="flat">
        <label class="form-check-label" for="pricingModeFlat">Flat Fee</label>
      </div>
    </div>

    <!-- Only the active pricing mode's inputs are shown; the hidden mode's
         values stay in the form model, so toggling never loses data. -->
    <div *ngIf="!isFlatMode" class="pricing-group">
      <div class="shop-time-row">
        <app-input [form]="form" formGroupName="shopHours" placeHolder="Shop Hours" inputType="integer"></app-input>
        <select class="form-select shop-minutes-select" formControlName="shopMinutes" aria-label="Minutes">
          <option value="">0 min</option>
          <option value="15">15 min</option>
          <option value="30">30 min</option>
          <option value="45">45 min</option>
        </select>
      </div>
      <app-input [form]="form" formGroupName="partsPricing" placeHolder="Parts Pricing" prefix="$" inputType="decimal"></app-input>
    </div>

    <div *ngIf="isFlatMode" class="pricing-group">
      <app-input [form]="form" formGroupName="flatFee" placeHolder="Flat Fee" prefix="$" inputType="decimal"></app-input>
      <div class="form-check noselect">
        <input class="form-check-input" type="checkbox" id="flatFeeTaxableCheck" formControlName="flatFeeTaxable">
        <label class="form-check-label" for="flatFeeTaxableCheck">Apply sales tax to this flat fee</label>
      </div>
    </div>
    <div *ngIf="isFlatMode" class="form-text noselect">
      This work item is priced at the flat fee; parts and labor are kept for reference only.
    </div>

    <div class="pricing-summary noselect">
      <ng-container *ngIf="!isFlatMode">
        <div class="summary-row"><span>Labor</span><span>{{ summaryLabor | currency }}</span></div>
        <div *ngIf="laborNeedsMechanic" class="summary-hint">Assign a mechanic to price labor.</div>
        <div class="summary-row"><span>Parts</span><span>{{ summaryParts | currency }}</span></div>
      </ng-container>
      <div *ngIf="isFlatMode" class="summary-row"><span>Flat fee</span><span>{{ summaryFlatFee | currency }}</span></div>
      <div class="summary-row summary-total"><span>Line total</span><span>{{ summaryTotal | currency }}</span></div>
      <div class="summary-tax-note">{{ summaryTaxNote }}</div>
    </div>
  </div>

  <div class="mb-2">
    <label for="workItemNotes" class="form-label noselect">Notes</label>
    <textarea id="workItemNotes"
              class="form-control work-item-notes-input"
              rows="4"
              maxlength="1000"
              formControlName="notes"></textarea>
  </div>
</div>
